$(document).ready(function(){
    $(".show_all").click(function(){
      console.log("Click");
      $(".page_links a").each(function(index){
       var link =  $(this).attr("href");
        console.log("Nuber"+ link);
$.ajax({
            type: "GET",
            url: link,
            dataType: 'html',
            success: function(data) 
            {
             var products =  $(data).find("#coll-product-list").html();
             console.log(products);
              $("#coll-product-list").append(products);
              $(".show_all").hide();
              $(".pagination.wide").hide();
            }
          })
})
      })
      var counting = $("#coll-product-list .grid-item").length
    var count_num = $(".count_products").text();
     counting = parseInt(counting);
  count_num = parseInt(count_num);
  console.log(count_num + " " + counting);
if(counting < count_num )
{
  $(".container_all").css("display","none");
}
  })